import { media, style } from "typestyle";
import colors from "../../styles/colors";
import mediaQueries, { upFrom } from "../../styles/mediaQueries";
import { px2, py1 } from "../../styles/spacing";

const HEADER_HEIGHT = 64;

export const wrapper = style({
  backgroundColor: "white",
  borderBottom: "1px solid #EAEAEA",
});

export const container = style({
  padding: "0 1.5rem",
  height: HEADER_HEIGHT,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const brand = style({
  height: "100%",
  display: "flex",
  alignItems: "center",
  zIndex: 2,
});

export const rightSide = style({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

export const rightSidePadding = style({
  $nest: {
    "&>*:last-child>button": {
      paddingRight: 0,
    },
  },
});

export const rightSideEventPadding = style(
  {
    $nest: {
      "&>*:last-child>button": {
        paddingRight: 0,
      },
    },
  },
  media(upFrom(mediaQueries.tablet), {
    $nest: {
      "&>*:nth-child(2)>button": {
        paddingRight: 0,
      },
    },
  }),
);

export const loggedInOrganizerLink = style({
  background: "#005CB4",
  padding: "0.5rem 0.75rem",
  borderRadius: "6px",
  $nest: {
    "&>span": {
      color: "white",
    },
    "&>svg": {
      color: "white",
    },
  },
});

export const eventPageFlag = style(
  {
    display: "none !important",
  },
  media(upFrom(mediaQueries.tablet), {
    display: "flex !important",
  }),
);

export const eventPageOrganizerLink = style(
  {
    display: "none !important",
  },
  media(upFrom(mediaQueries.tablet), {
    display: "flex !important",
  }),
);

export const titleWrapper = style(
  {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0,
    fontSize: 14.5,
    fontWeight: 500,
    display: "flex",
  },
  media(upFrom(mediaQueries.desktopSmall), {
    position: "absolute",
    width: "100%",
    left: 0,
    right: 0,
  }),
);

export const buttonWrapper = style({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 0,
  fontSize: 14.5,
  fontWeight: 500,
  margin: "0 0.5rem",
});

export const hamburgerMenuToggler = style(
  px2,
  py1,
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    color: colors.grey[600],
    cursor: "pointer",
    fontSize: 14,
    background: "inherit",
    border: "none",
    opacity: 0.85,
  },
  media(upFrom(mediaQueries.tablet), {
    marginLeft: "0.75rem",
  }),
);

export const divider = style({
  textTransform: "uppercase",
  fontSize: "0.75rem",
  margin: "0.25rem 0.5rem",
  letterSpacing: "1px",
  color: "#8C94A3",
});

export const hamburgerMenu = style({
  position: "absolute",
  borderRadius: "7px !important",
  top: 42,
  right: -20,

  backgroundColor: "white",
  zIndex: "30 !important",
  display: "none",
  $nest: {
    "&::before": {
      content: "''",
      transform: "rotate(45deg)",
      position: "absolute",
      display: "block",
      borderLeft: "1px solid rgba(213,218,230,1)",
      borderTop: "1px solid rgba(213,218,230,1)",
      right: 20,
      top: -6,
      width: "10px",
      height: "10px",
      backgroundColor: "white",
    },
  },
});

export const languageHeader = style({
  padding: `0.75rem 0.5rem 0.25rem`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  color: "rgba(0,0,0,0.65)",
  $nest: {
    "&>span": {
      fontSize: "0.75rem",
    },
    "&>button": {
      border: "none",
      background: "transparent",
      cursor: "pointer",
      color: "rgba(0,0,0,0.65)",
    },
  },
});

export const languageMenu = style(
  {
    right: -41,
    $nest: {
      "&::before": {
        right: 54,
      },
    },
  },
  media(upFrom(mediaQueries.tablet), {
    right: -20,
    $nest: {
      "&::before": {
        right: 38,
      },
    },
  }),
);

export const hamburgerMenuInner = style({
  borderRadius: "7px",
  overflow: "hidden",
  $nest: {
    "&>*:not(:first-child)": {
      $nest: {
        "&>div": {
          borderTop: "1px solid rgba(0,0,0,0.07)",
        },
      },
    },
    "&>button": {
      padding: "0 0.5rem",
    },
  },
});

export const organizerLink = style({
  display: "flex",
  flexDirection: "row",
  zIndex: "2",
  alignItems: "center",
  justifyContent: "center",
  color: "rgba(0,0,0,0.35)",
  fontSize: 14,
  $nest: {
    "&>*:first-child": {
      marginRight: "0.25rem",
    },
  },
});

export const hamburgerMenuOpen = style({ display: "block" });

export const menuOuter = style({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  background: "inherit",
  minWidth: "180px",
  border: 0,

  $nest: {
    "&:hover": {
      backgroundColor: "rgba(246,246,248,1)",
      textDecoration: "none",
    },
  },
});

export const hamburgerMenuOuter = style({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  background: "inherit",
  minWidth: "min(340px, 90vw)",
  border: 0,
  padding: "0px 0.5rem",
  position: "relative",
  zIndex: 40,

  $nest: {
    "&:hover": {
      backgroundColor: "rgba(246,246,248,1)",
      textDecoration: "none",
    },
  },
});

export const menuItem = style({
  padding: `0.75rem 0.5rem`,
  display: "flex",
  alignItems: "center",
  fontSize: "0.875rem",
  width: "100%",
});

export const hamburgerMenuItem = style({
  display: "flex",
  padding: `0.75rem 0.5rem`,
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  $nest: {
    "&::after": {
      content: "'\u2192'",
      color: "rgba(0,0,0,0.5)",
      fontSize: "1.125rem",
    },
  },
});

export const icon = style({
  background: colors.grey[400],
  borderRadius: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
});
export const hamburgerMenuComp = style(
  {
    display: "block !important",
  },
  media(upFrom(mediaQueries.tablet), { display: "none !important" }),
);

export const hamburgerMenuItemInner = style({
  display: "flex",
  marginLeft: "0.5rem",
  flexDirection: "column",
  fontSize: "0.875rem",
  width: "100%",
  $nest: {
    "&>span:first-child": {
      fontWeight: 600,
    },
    "&>span:last-child": {
      color: "rgba(0,0,0,0.7)",
      fontSize: "0.75rem",
    },
  },
});

export const flag = style({
  display: "flex",
  opacity: 0.7,
  borderRadius: "2px",
  overflow: "hidden",
  marginRight: "6px",
  $nest: {
    svg: {
      height: "12px",
    },
  },
});

export const appHeaderButtonText = style({
  display: "flex",
  cursor: "pointer",
  color: "rgba(25, 25, 25, 0.7)",
  lineHeight: 1,
});
